import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { SocialMediaCoreDomainNameStringAssets } from "../../../../../assets/stringAssets";

/**
 * @function referenceIsForAYouTubeAsset Returns whether the socialMediaPostRawReference is for a YouTube asset
 * @param socialMediaPostRawReference
 */
export const referenceIsForAYouTubeAsset: (socialMediaPostRawReference: string) => boolean = (socialMediaPostRawReference: string) => {
  // return value (defaulted to 'false') indicating whether the socialMediaPostRawReference matches a known regular expression
  let foundMatchForRawReference: boolean = false;

  // as a quick check, determine whether this social media's core domain name is found within the raw reference
  const rawReferenceLowerCase: string = socialMediaPostRawReference.toLowerCase();
  if ((rawReferenceLowerCase.search(SocialMediaCoreDomainNameStringAssets.YouTubeRegular.toLowerCase()) !== -1) ||
      (rawReferenceLowerCase.search(SocialMediaCoreDomainNameStringAssets.YouTubeShortened.toLowerCase()) !== -1)) {

    // test for each type of raw reference for this social media type until a match is found or the list of social media types has been exhausted
    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.YouTube.test(socialMediaPostRawReference);
    }
  }

  // return the result of testing the given socialMediaPostRawReference against the regex pattern(s)
  return foundMatchForRawReference;
}
